import { render } from "./SeeProducts.vue?vue&type=template&id=7366b709"
import script from "./SeeProducts.vue?vue&type=script&lang=js"
export * from "./SeeProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__